import React from 'react';
import { ComboCard } from './ComboCard';
export function CheckoutSection() {
  const handleBuy = (combo: string, value: number) => {
    console.log(`Buying ${combo}`);
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: combo,
        currency: 'ARS',
        value
      });
    }
    // Replace with real checkout URLs
    // window.location.href = 'https://tu-link-de-pago.com'
  };
  return <section id="checkout" className="py-24 px-4 bg-zinc-950" data-id="element-34">
      <div className="max-w-6xl mx-auto" data-id="element-35">
        <div className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-37">
            Elegí Tu Nivel
          </h2>
          <p className="text-red-500 font-bold animate-pulse" data-id="element-38">
            ⚠ Oferta con bonos por tiempo limitado
          </p>
          <div className="mt-12 flex flex-col items-center gap-3" data-id="element-39">
            <p className="text-zinc-500 text-sm font-medium tracking-wide uppercase" data-id="element-40">
              Pago 100% seguro procesado por:
            </p>
            <div className="bg-white rounded-xl px-6 py-3" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/6RgxCNUWQNHbPB8GHoh8H2/pasted-image.png" alt="Mercado Pago" className="h-10 object-contain" data-id="element-42" />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-43">
          <ComboCard title="COMPLETO PARA EMPEZAR" price="19.990" originalPrice="39.990" discount="50%" features={['Manual Principal Huerta 360º (PDF digital)', 'BONUS 1: Calendario Productivo Anual', 'BONUS 2: Fertilizantes Naturales', 'BONUS 3: Mini Invernadero Low Cost', '📧 Envío automático a tu email']} onBuy={() => handleBuy('combo1', 19990)} image="https://cdn.magicpatterns.com/uploads/g11yz5Ge345x3jkYLPDgxK/ChatGPT_Image_24_feb_2026,_15_07_28.png" data-id="element-44" />

          <ComboCard title="MÁS ELEGIDO" price="29.990" originalPrice="59.990" discount="50%" isRecommended features={['Todo el Combo 1', 'Manual 2: Huerta Intensiva y Optimización (PDF digital)', '📧 Envío automático a tu email']} onBuy={() => handleBuy('combo2', 29990)} image="https://cdn.magicpatterns.com/uploads/6m5eYAacr2gLoLjeEM4sYz/ChatGPT_Image_24_feb_2026,_16_15_47.png" data-id="element-45" />

          <ComboCard title="NIVEL EMPRENDEDOR" price="39.990" originalPrice="79.990" discount="50%" isPremium features={['Todo el Combo 1 y Combo 2', 'Manual 3: Huerta como Emprendimiento (PDF digital)', '📧 Envío automático a tu email']} onBuy={() => handleBuy('combo3', 39990)} image="https://cdn.magicpatterns.com/uploads/61gGfJb5mL4j38HMcDutYv/ChatGPT_Image_24_feb_2026,_16_33_57.png" data-id="element-46" />
        </div>
      </div>
    </section>;
}